import { SessionIdentity } from '@samelogic/steps';
import { SessionProperties } from '../models';

export class Metrics {
  constructor(
    private readonly sessionIdentity: SessionIdentity,
    private readonly sessionProperties: SessionProperties
  ) {}
}
